import React from 'react';
import AuthForm from './auth-form.jsx';
import AuthShell from './auth-shell.jsx';

function AuthFullScreenResetPassword() {
	return <AuthShell variant="full-screen"><AuthForm variant="full-screen" mode="reset-password" /></AuthShell>;
}

export default AuthFullScreenResetPassword;
